/**
 * Safari and some mobile browsers can report geolocation "denied" (GeoComply 803)
 * before the Permissions API / prompt state has settled. Retry only when the
 * browser has not permanently denied access.
 */
export async function getGeolocationPermissionState(): Promise<
  PermissionState | 'unknown'
> {
  try {
    if (!navigator.permissions?.query) {
      return 'unknown';
    }

    const status = await navigator.permissions.query({ name: 'geolocation' });
    return status.state;
  } catch {
    return 'unknown';
  }
}

export const shouldAutoRetryTransient803 = async (): Promise<boolean> => {
  const permissionState = await getGeolocationPermissionState();
  return permissionState !== 'denied';
};
